import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/data/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink("Namaste Waghe & Sons! I'd like to know more about your products.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#1ebe5d] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(30,190,93,0.4)] animate-pulse-gold transition-[transform,background-color] duration-300 hover:scale-110 hover:bg-[#22d367]"
    >
      <MessageCircle className="w-6 h-6" />
    </a>
  );
}
